import { render, staticRenderFns } from "./pageTabs.vue?vue&type=template&id=7d24d2f1&scoped=true"
import script from "./pageTabs.vue?vue&type=script&lang=js"
export * from "./pageTabs.vue?vue&type=script&lang=js"
import style0 from "./pageTabs.vue?vue&type=style&index=0&id=7d24d2f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d24d2f1",
  null
  
)

export default component.exports